module.exports = __webpack_public_path__ + "img/sm.f5665000.svg";